import { styled } from "@mui/system";
import ReactMarkdown from "react-markdown";

export const StyledMarkdown = styled(ReactMarkdown)({
    color: "var(--community-color-primary-text)",
    width: "100%",
    fontSize: "14px",
    whiteSpace: "pre-wrap",
    p: {
        margin: 0,
        wordBreak: "break-word",
    },
    ul: {
        whiteSpace: "normal",
        margin: "unset",
        listStyle: "disc",
    },
    ol: {
        whiteSpace: "normal",
        margin: "unset",
    },
});
